<template>
    <div class="header_top">
        <BqHeader style="z-index: 3;" :productList="productList" :isPerson="true"
            :key="keyValue" :kefushow="true">
            <template #productLogo>
                <img src="../assets/MagicPPT.svg" alt="">
            </template>
            <template #productName>
                <img src="../assets/name.svg" alt="">
            </template>
            <template #productLogin>
                <span class="innerspan" @click="login">登录/注册</span>
            </template>
        </BqHeader>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import PublicApi from 'yk-chat-public';
import { ElMessage } from 'element-plus'
import { BqHeader } from 'y-p-h';
import 'y-p-h/demo-ui.css';
import { getCookie, clearAllCookie } from '../utils/cookei';
const props = defineProps({
    activeNav: {
        type: Number,
        default: 0
    }
})

let productList = ref([])

onMounted(() => {
    getNavList();
})
const getNavList = () => {
    let code = 1;
    // 添加重试机制获取UserInfo
    const getUserInfo = () => {
        const userInfo = getCookie('UserInfo');
        if (userInfo) {
            try {
                const parsedInfo = JSON.parse(userInfo);
                if (parsedInfo && parsedInfo.loginType) {
                    return parsedInfo.loginType;
                }
            } catch (e) {
                console.error('解析UserInfo失败:', e);
            }
        }
        return null;
    };

    // 尝试获取用户信息，最多重试5次
    let retryCount = 0;
    const maxRetries = 3;

    const tryGetUserInfo = () => {
        const userInfoCode = getUserInfo();
        if (userInfoCode !== null) {
            code = userInfoCode;
            makeApiRequest();
        } else if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(tryGetUserInfo, 500); // 增加到500ms后重试
        } else {
            makeApiRequest();
        }
    };

    // 将API请求封装成单独的函数
    const makeApiRequest = () => {
        PublicApi.getNavListApi(process.env.VUE_APP_LOGIN_URL, { type: code }, getCookie('Token')).then((res) => {
            if (res.code === 0) {
                productList.value = res.data;
            } else if (res.code === 400) {
                productList.value = [];
                ElMessage.error(res.msg);
                setTimeout(() => {
                    clearAllCookie();
                    window.location.reload();
                }, 2000);
            } else {
                productList.value = [];
            }
        }).catch((error) => {
            console.error('API请求错误:', error);
            productList.value = [];
        });
    };

    // 开始尝试获取用户信息
    tryGetUserInfo();
}

const login = () => {
    const domain = window.location.hostname;
    const productId = productList.value.find((item) => item.domain_name.includes(domain))?.product_id || 77;
    const redirectUrl = sessionStorage.getItem('redirect_url') || '';
    if (localStorage.getItem('loginTypeName')) {
        var url = ''
        if (localStorage.getItem('loginTypeName') == 'chatlibrary') {
            url = 'https://chatlibrary.newacademic.net/?again=true&redirect=' + productId
        } else if (localStorage.getItem('loginTypeName') == 'xuanniao') {
            url = 'https://xuanniao.newacademic.net/?again=true&redirect=' + productId
        } else if (localStorage.getItem('loginTypeName') == 'chatmed') {
            url = 'https://chatmed.newacademic.net/?again=true&redirect=' + productId
        } else if (localStorage.getItem('loginTypeName') == 'chatpubliclibrary') {
            url = 'https://chatpubliclibrary.newacademic.net/?again=true&redirect=' + productId
        } else if (localStorage.getItem('loginTypeName') == 'chatpub') {
            url = 'https://chatpub.newacademic.net/?again=true&redirect=' + productId
        }
        if (redirectUrl) {
            url += '&redirect_url=' + encodeURIComponent(redirectUrl)
        }
        if (window.location.href.indexOf('test') > -1) {
            window.location.href = url.split('://')[0] + '://test' + url.split('://')[1]
        } else {
            window.location.href = url
        }
    } else {
        var url = 'https://chatlibrary.newacademic.net/?again=true&redirect=' + productId
        if (redirectUrl) {
            url += '&redirect_url=' + encodeURIComponent(redirectUrl)
        }
        if (window.location.href.indexOf('test') > -1) {
            window.location.href = url.split('://')[0] + '://test' + url.split('://')[1]
        } else {
            window.location.href = url
        }
    }
    if (redirectUrl) {
        sessionStorage.removeItem('redirect_url')
    }
}

</script>
<style lang="scss" scoped>
.header_top {
    width: 100%;
    min-width: 1200px;
    height: 60px;
    background-color: #fff;
    position: relative;
    z-index: 3;

    .warp {
        width: 80%;
        height: 100%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
            display: flex;
            align-items: center;
        }
    }

    .left_logo {
        font-weight: 700;
        font-size: 25px;
        font-family: Source Han Sans, Source Han Sans !important;
        color: #3547E4;
        cursor: pointer;

        .large {
            color: #3547E4;
        }
    }

    .language_img {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #3547E4;
        font-size: 14px;

        .login_out {
            cursor: pointer;
        }

        .personal_center {
            cursor: pointer;

            &:hover {
                color: #3547E4;
            }
        }
    }

    .white_warp {
        width: 100%;
        height: calc(100vh - 65px); // 60px是header的高度
        box-sizing: border-box;
        position: absolute;
        top: 60px;
        left: 0;
        font-size: 16px;
        z-index: 2;

        .main_area {
            padding: 20px 0;
            width: 100%;
            background: rgba(243, 244, 255, 0.5);
            box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

            .product_area {
                width: 100%;

                ul {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    padding: 0 5%;
                    box-sizing: border-box;

                    li {
                        width: 33.333%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        padding: 10px;
                        color: #666;
                        cursor: pointer;
                        box-sizing: border-box;

                        span {
                            &:hover {
                                color: #6A79FF;
                            }
                        }
                    }
                }
            }
        }

    }
}

.product_area {
    display: flex;
    align-items: center;

    span {
        color: #383b41;
        font-size: 14px;
        cursor: pointer;
        margin-left: 40px;
    }
}

.innerspan {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.product_list {
    font-size: 14px;
    display: flex;
    align-items: center;
    outline: none;
    cursor: pointer;
    color: #666;
    margin-right: 20px;
    border: 1px solid #dcdfe6;
    padding: 5px 10px;
    border-radius: 4px;
}
</style>